/**
 * Category tag styles using design system tokens.
 *
 * Maps call categories to the 6 prototype tag colors:
 * primary (teal), success (green), warning (yellow), danger (red), info (blue), neutral (gray)
 *
 * Old function kept for backwards compatibility but deprecated.
 */

/** Design-token tag styles (no border — matches prototype .tag) */
export function getCategoryTagStyle(category: string): string {
  switch (category) {
    case 'missed':
      return 'bg-danger/10 text-danger';
    case 'short':
      return 'bg-warning/10 text-warning';
    case 'purchase':
      return 'bg-success/10 text-success';
    case 'support':
      return 'bg-info/10 text-info';
    case 'complaint':
      return 'bg-danger/10 text-danger';
    case 'product_inquiry':
      return 'bg-primary/10 text-primary';
    case 'billing':
      return 'bg-warning/10 text-warning';
    case 'scheduling':
      return 'bg-info/10 text-info';
    case 'cancellation':
      return 'bg-danger/10 text-danger';
    case 'follow_up':
      return 'bg-primary/10 text-primary';
    case 'onboarding':
      return 'bg-success/10 text-success';
    default:
      return 'bg-primary/10 text-primary';
  }
}

/** @deprecated Use getCategoryTagStyle instead */
export function getCategoryBadgeStyle(category: string): string {
  return getCategoryTagStyle(category);
}
